export const isDefined = <T>(value: T | undefined): value is T => value !== undefined;
export const isNotNull = <T>(value: T | null): value is T => value !== null;
export const isTruthy = <T, >(value: T | false | undefined | null | 0 | ''): value is T => Boolean(value);
